export default "__VITE_ASSET__424bcd5b__"